import React from 'react'
import { PropTypes } from 'prop-types'
const LandUseContext = (props) => (
  <svg
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18.42 18.42"
    fill={props.fill ? props.fill : '#262626;'}
    width="30"
    height="30"
  >
    <g id="Layer_1-2">
      <path
        className="cls-1"
        d="m0,18.42V4.22h4.22V0h9.98v8.44h4.22v9.98h-7.85v-4.22h-2.71v4.22H0Zm1.53-1.53h2.69v-2.69H1.53v2.69Zm0-4.22h2.69v-2.69H1.53v2.69Zm0-4.22h2.69v-2.69H1.53v2.69Zm4.22,4.22h2.69v-2.69h-2.69v2.69Zm0-4.22h2.69v-2.69h-2.69v2.69Zm0-4.22h2.69V1.53h-2.69v2.69Zm4.22,8.44h2.69v-2.69h-2.69v2.69Zm0-4.22h2.69v-2.69h-2.69v2.69Zm0-4.22h2.69V1.53h-2.69v2.69Zm4.22,12.66h2.69v-2.69h-2.69v2.69Zm0-4.22h2.69v-2.69h-2.69v2.69Z"
      />
    </g>
  </svg>
)

export default LandUseContext
LandUseContext.propTypes = {
  fill: PropTypes.string
}
